// User listing
export const GET_USER_LIST = "GET_USER_LIST";
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS";
export const GET_USER_LIST_ERROR = "GET_USER_LIST_ERROR";

// User detail
export const GET_USER_DETAIL = "GET_USER_DETAIL";
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAIL_ERROR = "GET_USER_DETAIL_ERROR";

// User groups
export const GET_USER_GROUPS = "GET_USER_GROUPS";
export const GET_USER_GROUPS_SUCCESS = "GET_USER_GROUPS_SUCCESS";
export const GET_USER_GROUPS_ERROR = "GET_USER_GROUPS_ERROR";

export const GET_EXPORT_USER_LIST = "GET_EXPORT_USER_LIST";
export const GET_EXPORT_USER_LIST_SUCCESS = "GET_EXPORT_USER_LIST_SUCCESS";
export const GET_EXPORT_USER_LIST_ERROR = "GET_EXPORT_USER_LIST_ERROR";

//delete
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";

// delete user profile image
export const DELETE_USER_IMAGE = "DELETE_USER_IMAGE";
export const DELETE_USER_IMAGE_SUCCESS = "DELETE_USER_IMAGE_SUCCESS";
export const DELETE_USER_IMAGE_ERROR = "DELETE_USER_IMAGE_ERROR";

//edit

export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_ERROR = "EDIT_USER_ERROR";

//setting data for edit
export const SET_USER_LIST = "SET_USER_LIST";

// set search of ingredients
export const SET_USER_SEARCH = "SET_USER_SEARCH";

// set sortField of ingredients
export const SET_USERS_SORT_FIELD = "SET_USERS_SORT_FIELD";

// set sortOrder of ingredients
export const SET_USERS_SORT_ORDER = "SET_USERS_SORT_ORDER";

// set page of ingredients
export const SET_USERS_PAGE = "SET_USERS_PAGE";
